import { SuccessfulAuth } from "../../auth/authSlice";
import { decodeIdToken } from "../clients/decodeIdToken";

interface Props {
  accessToken: string;
  idToken: string;
  refreshToken: string;
  expiresIn: number;
}

const getUserInfo = ({
  accessToken,
  idToken,
  refreshToken,
  expiresIn,
}: Props) =>
  new Promise<SuccessfulAuth>((resolve, reject) => {
    const {
      companyName,
      name,
      userImage,
      idTokenError,
      companyId,
      email,
      userId,
      roles,
    } = decodeIdToken(idToken);

    if (idTokenError) {
      reject(idTokenError);
    }

    const expiresAt = Date.now() + expiresIn * 1000;

    resolve({
      email,
      accessToken,
      userId: userId as string,
      companyName,
      name,
      userImage,
      roles,
      companyId,
      refreshToken,
      expire: expiresIn,
      expiresAt,
    });
  });
export { getUserInfo };
